import type { ReactNode } from 'react';
import {
  formatOtsDateTime,
  getFormattedDateTime,
  type DateTimeFormatOptions,
  type OtsDateTimeFormat,
} from '@ots-frontend/ots-data';

export type OtsDateTimeProps = DateTimeFormatOptions & {
  value?: Date | number | null;
  empty?: ReactNode;
  displayTime?: boolean;
  displaySeconds?: boolean;
  /** A named layout ("time", "short", "weekday"); the numeric date and time when left out. */
  format?: OtsDateTimeFormat;
  className?: string;
};

/** Read-only date foundation, using the same formatter as FormattedDateTime. */
export const OtsDateTime = ({
  value,
  empty = '—',
  displayTime = true,
  displaySeconds = false,
  format,
  className,
  ...options
}: OtsDateTimeProps) => {
  const instant = value == null ? undefined : new Date(value);
  if (!instant || !Number.isFinite(instant.getTime()))
    return <span className={className}>{empty}</span>;
  return (
    <time dateTime={instant.toISOString()} className={className}>
      {format && format !== 'numeric'
        ? formatOtsDateTime(value!, format, options)
        : getFormattedDateTime(value!, displayTime, displaySeconds, options)}
    </time>
  );
};
